import { host } from './../../environments/environment';
import axios from 'axios';
import { captureException } from '@sentry/react';

export interface BankGiro {
  name: string;
  orgnr: string;
  bgnr: string;
}

export const getBankgiro = async (searchStr: string) => {
  const url = new URL('lookup-service/bankgirot/search', host.clientUrl);
  searchStr = searchStr.trim();
  if (searchStr.match(/\d{6}-?\d{4}/)) {
    url.searchParams.append('orgnr', searchStr);
  } else if (searchStr.match(/\d{3,4}-\d{4}/)) {
    url.searchParams.append('bgnr', searchStr);
  } else {
    url.searchParams.append('company', searchStr);
  }

  try {
    const res = await axios.get<BankGiro[]>(url.toString());
    if (res.status === axios.HttpStatusCode.Ok) {
      return res.data;
    }
    return [];
  } catch (e) {
    captureException(e);
    return [];
  }
};
